import { MIN_LOAN_AMOUNT, MAX_LOAN_AMOUNT } from 'utils/constants';
import { floatUnmask, removeSpace } from 'utils/masks';

const LoanDetailsSchema = {
  repaymentType: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  coin: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  requestedAmount: [{
    rule: 'required',
    isValid: (input) => {
      if (!input || removeSpace(input).length === 0) {
        return 'The input field is required';
      }
      
      return ((Number(floatUnmask(input)) < MIN_LOAN_AMOUNT) || Number(floatUnmask(input)) > MAX_LOAN_AMOUNT) ? 'Loan Amount should be between $10,000.00 and $250,000.00' : true;
    },
  }],
};

export default LoanDetailsSchema;
